import { Routes } from '@angular/router';
import { permissionGuard } from '@core/auth/permission.guard';
import { APP_PERMISSIONS } from '@core/constants/permission.constants';
import { APP_ROUTES } from '@core/constants/routes.constants';

export const climateVariablesRoutes: Routes = [
  {
    title: 'pagesTitles.climateVariables',
    path: APP_ROUTES.CLIMATE_VARIABLES,
    canActivate: [permissionGuard(APP_PERMISSIONS.ClimateVariableRead)],
    loadComponent: () =>
      import('./pages/climate-variables-list').then((m) => m.ClimateVariablesList),
  },
];
